// extracted by mini-css-extract-plugin
module.exports = {"logo":"style_logo__QwQu6","disabled":"style_disabled__1IJd3"};